import Model from '@models/model';
import { get, kebabCase } from 'lodash';
import Vue from 'vue';

Vue.mixin({
    computed: {
        isSystemAdmin() {
            return this.$authorization.hasRole(this.$authorization.roles.SYSTEM_ADMIN);
        },
    },
    methods: {
        generateElementId(suffix, object, prefixes = ['dataCy', 'id', 'name', 'label', 'title']) {
            let prefix;
            // eslint-disable-next-line no-restricted-syntax
            for (prefix of prefixes) {
                if (object) {
                    prefix = get(object, prefix);
                } else {
                    // Read from $props/$attrs/$data containers explicitly. A
                    // bare `this[prefix]` access for a prop the consumer
                    // didn't declare emits a Vue 3 dev warning ("accessed
                    // during render but not defined on instance"). Most
                    // callers only declare a subset of these prefixes, so
                    // the probe was emitting many warns per render. The
                    // public $props/$attrs/$data accessors don't proxy
                    // through the warn check.
                    prefix = (this.$props && this.$props[prefix])
                        || (this.$attrs && this.$attrs[prefix])
                        || (this.$data && this.$data[prefix]);
                }

                if (prefix) {
                    break;
                }
            }

            return kebabCase(`${prefix || ''}-${suffix}`);
        },
        generateId(string) {
            return Model.generateNumericId(string);
        },
    },
});
